import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpserviceService } from '../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../service/utils.service';
import { GlobalConfig } from '../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap';

@Component({
  selector: 'app-set-permission',
  templateUrl: './set-permission.component.html',
  styleUrls: ['./set-permission.component.css']
})
export class SetPermissionComponent implements OnInit {
  @ViewChild('permissionTabs') permissionTabs: TabsetComponent;
  permissionID: any = '';
  noResult = false;
  permissionId: 0;
  apiUrl: any = '';
  roleForm: FormGroup;
  formErrors: any;
  submitted: Boolean = false;
  isEdit: Boolean = false;
  constructor(
    private route: ActivatedRoute,
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager
  ) {
    this.permissionID = route.snapshot.params['id'];
  }
  routeList: any[] = [];
  routeDetail: any[] = [];
  savedRoutes: any[] = [];
  savedRoles: any[] = [];
  permissionsList: any[] = [];

  roleList: any[] = [];
  roleDetail: any[] = [];
  permissionRoleList: any[] = [];

  permissions: any = [];
  permissionsIds: any[] = [];

  permissionRoutPermission: any[] = [];
  rolePermissioRoleList: any[] = [];
  permission: any = {
    permissionName: '',
    displayName: '',
    description: '',
    enabled: 0
  };

  ngOnInit() {
    this.disableTab();
    this.apiUrl = this.config.apiRootUrl;
    if (this.permissionID > 0) {
      this.isEdit = true;
      this.getPermissionDetail(this.permissionID);
    }
  }

  disableTab() {
    this.permissionTabs.tabs[1].disabled = true;
    this.permissionTabs.tabs[2].disabled = true;
    this.permissionTabs.tabs[3].disabled = true;

  }

  selectTab(tab_id: number) {
    this.permissionTabs.tabs[tab_id].disabled = false;
    this.permissionTabs.tabs[tab_id].active = true;
  }

  getPermissions() {
    this.servicesComponent.getPermissions()
      .then((response: any) => {
        if (response.success) {
          this.permissionsList = response.receiveObj;
          // this.mapIds();
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  checkValidation(form) {
    this.submitted = false;
    if (form.valid) {
      this.permissionTabs.tabs[1].disabled = false;
      this.permissionTabs.tabs[1].active = true;
    }
    else {
      this.submitted = true;
    }
  }

  addPermission() {
    if (this.permission.enabled == true) {
      this.permission.enabled = 1;
    }
    else {
      this.permission.enabled = 0;
    }
    this.servicesComponent.savePermission(this.permission)
      .then((response: any) => {
        if (response.receiveObj.success == true) {
          this.permissionId = response.receiveObj.result.id;
          this.toastr.success('role saved successfully.', 'Success!');
          this.permissionTabs.tabs[2].disabled = false;
          this.permissionTabs.tabs[2].active = true;

          if (this.isEdit == true) {
            this.getRoutesByPermission(this.permissionId);
          }
        }
        else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }

      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  addRoutePermissions() {
    if (this.permissionRoutPermission.length > 0) {
      this.servicesComponent.addRoutePermissions(this.permissionRoutPermission)
        .then((response: any) => {
          if (response.success == true) {
            this.toastr.success('route Permissions add successfully.', 'Success!');
            this.permissionTabs.tabs[3].disabled = false;
            this.permissionTabs.tabs[3].active = true;
            if (this.isEdit == true) {
              this.getRolesByPermissionId(this.permissionId);
            } 
          }
          else {
            this.toastr.error('Some error occured, Please contact admin.', 'Error!');
          }

        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    }
    else {
      this.permissionTabs.tabs[3].disabled = false;
      this.permissionTabs.tabs[3].active = true;
    }
  }

  routeTypeHead(event) {
    this.getRouteListByName(event.target.value);
  }

  typeaheadOnSelectRoute(item) {
    if (item != null) {
      this.routeDetail.push(item.item);
      this.permissionRoutPermission.push({ id: item.item.id, permissionId: this.permissionId, routeName: item.item.routeName })
    }
  }

  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
  }

  deleteRouteArray(index) {
    if (this.routeDetail.length > 0) {
      this.routeDetail.splice(index, 1);
      this.permissionRoutPermission.splice(index, 1);
    }
  }

  getRouteListByName(name) {
    if (name != "") {
      this.servicesComponent.getRouteListByName(name)
        .then((response: any) => {
          if (response.success == true) {
            this.routeList = response.receiveObj;

          }
          else {
            this.toastr.error('Some error occured, Please contact admin.', 'Error!');
          }

        })
    }
  }

  roleTypeHead(event) {
    this.getRoleListByName(event.target.value);
  }

  getRoleListByName(name) {
    if (name != "") {
      this.servicesComponent.getRoleListByName(name)
        .then((response: any) => {
          if (response.success == true) {
            this.roleList = response.receiveObj;
          }
          else {
            this.toastr.error('Some error occured, Please contact admin.', 'Error!');
          }

        })
    }
  }

  getPermissionDetail(id) {
    this.servicesComponent.getPermissionDetail(id)
      .then((response: any) => {
        if (response.success) {
          this.permission = response.receiveObj;

        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  typeaheadOnSelectRole(item) {
    if (item != null) {
      this.roleDetail.push(item.item);
      this.permissionRoleList.push({ id: this.permissionId, roleId: item.item.id });
    }
  }

  savePermissionRole() {
    if (this.permissionRoleList.length > 0) {
      this.servicesComponent.savePermissionRole(this.permissionRoleList)
        .then((response: any) => {
          if (response.success == true) {
            this.toastr.success('route Permissions add successfully.', 'Success!');
            this.router.navigate(['./permission']);
          }
          else {
            this.toastr.error('Some error occured, Please contact admin.', 'Error!');
          }

        })
        .catch(error => {
          console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    }
    else {
      this.router.navigate(['./permission']);
    }
  }

  deleteRoleArray(index) {
    if (this.roleDetail.length > 0) {
      this.roleDetail.splice(index, 1);
      this.permissionRoleList.splice(index, 1);
    }
  }

  getRoutesByPermission(id) {
    this.servicesComponent.getRoutesByPermissionId(id)
      .then((response: any) => {
        if (response.success) {
          this.savedRoutes = response.receiveObj;
          this.bindSavedRoutes();

        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getRolesByPermissionId(id) {
    this.servicesComponent.getRolesByPermissionId(id)
      .then((response: any) => {
        if (response.success) {
          this.savedRoles = response.receiveObj;
          this.bindSavedRole();

        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  bindSavedRoutes() {
    this.savedRoutes.forEach(a => {
      this.routeDetail.push(a);
      this.permissionRoutPermission.push({ id: a.id, permissionId: this.permissionId, routeName: a.routeName });
    });
  }

  bindSavedRole() {
    this.savedRoles.forEach(a => {
      this.roleDetail.push(a);
      this.permissionRoleList.push({ id: this.permissionId, roleId: a.id});
    });
  }
}




// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/permission/set-permission/set-permission.component.ts